import { useMutation } from "react-query"
import api from "../client"
import { AddressesResponseData } from "../types/address"
import { UpdateSettingsPayload } from "../types/settings"

const postData = async (payload: UpdateSettingsPayload) => {
    const { data } = await api.put<AddressesResponseData>(
        `/settings`,
        payload
    )
    return data
}

export const useUpdateSettings = () => {
    return useMutation((payload: UpdateSettingsPayload) => {
        return postData(payload)
    })
}
